// extracted by mini-css-extract-plugin
export default {"legendItem":"CustomDonutChart_legendItem__0hM4B","dot":"CustomDonutChart_dot__i8wVi","value":"CustomDonutChart_value__e4iG3"};